import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubPortfolioProjectsComponent } from './sub-portfolio-projects.component';


const routes: Routes = [
  {
    path: '',
    component: SubPortfolioProjectsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubPortfolioProjectsRoutingModule { }
